export const AUTH_SIGNIN_ROUTE: string = 'auth/signin';
export const AUTH_SIGNUP_ROUTE: string = 'auth/signup';

export const AGENT_BUILDER_ROUTE: string = 'agent/builder';

export const ORGANIZATION_BUILDER_ROUTE: string = 'organization/builder';

export const UNIT_DETAILS_ROUTE: string = 'unit/details';
